import {
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
} from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import EventIcon from "@mui/icons-material/Event";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import ExitToAppOutlinedIcon from "@mui/icons-material/ExitToAppOutlined";
import FormatListBulletedOutlinedIcon from "@mui/icons-material/FormatListBulletedOutlined";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

interface Page {
  title: string;
  url: string;
  icon: any;
  indent?: boolean;
}

const survayPages = (t: any): Page[] => [
  {
    title: "EQ-5D-5L",
    url: "/EQ-5D-5L",
    icon: <AddOutlinedIcon sx={{ color: "black" }} />,
    indent: true,
  },
];

const pages = (t: any): Page[] => [
  {
    title: t("navbar.symptoms_diary"),
    url: "/symptomdiary",
    icon: <AddOutlinedIcon sx={{ color: "black" }} />,
  },
  {
    title: t("navbar.antibiotics"),
    url: "/antibiotics",
    icon: <AddOutlinedIcon sx={{ color: "black" }} />,
  },
  {
    title: t("navbar.immunglobulin"),
    url: "/immunoglobulin",
    icon: <AddOutlinedIcon sx={{ color: "black" }} />,
  },
  {
    title: t("navbar.sick_days"),
    url: "/sickdays",
    icon: <AddOutlinedIcon sx={{ color: "black" }} />,
  },
  {
    title: t("navbar.care_days"),
    url: "/caredays",
    icon: <AddOutlinedIcon sx={{ color: "black" }} />,
  },
  {
    title: t("navbar.vaccination"),
    url: "/vaccination",
    icon: <AddOutlinedIcon sx={{ color: "black" }} />,
  },
  {
    title: t("navbar.my_notes"),
    url: "/mynotes",
    icon: <AddOutlinedIcon sx={{ color: "black" }} />,
  },
  {
    title: t("navbar.calendar"),
    url: "/calendar",
    icon: <EventIcon sx={{ color: "black" }} />,
  },
  {
    title: t("navbar.help"),
    url: "/help",
    icon: <QuestionMarkIcon sx={{ color: "black" }} />,
  },
  {
    title: t("navbar.about"),
    url: "/about",
    icon: <InfoOutlinedIcon sx={{ color: "black" }} />,
  },
];

interface ListButtonProps {
  title: string;
  onClick: () => void;
  icon: any;
  indent?: boolean;
}

const ListButton = ({ title, onClick, icon, indent }: ListButtonProps) => {
  return (
    <ListItem disablePadding>
      <ListItemButton onClick={onClick} sx={{ marginLeft: indent ? 2 : 0 }}>
        <ListItemIcon sx={{ minWidth: 32 }}>{icon}</ListItemIcon>
        <ListItemText primary={title} />
      </ListItemButton>
    </ListItem>
  );
};

interface DrawerContentProps {
  onLinkClick: (url: string) => void;
  onLogout: () => void;
}

const DrawerContent = ({ onLinkClick, onLogout }: DrawerContentProps) => {
  const { t } = useTranslation();
  const [survaysOpen, setSurvaysOpen] = useState<boolean>(false);
  return (
    <List>
      <ListButton
        key="home"
        title={t("navbar.home")}
        onClick={() => {
          onLinkClick("/home");
        }}
        icon={<HomeIcon sx={{ color: "black" }} />}
      />
      <Divider />
      <ListButton
        key={"surveys"}
        title={t("navbar.lifestyle_surveys")}
        onClick={() => {
          setSurvaysOpen((prev) => !prev);
        }}
        icon={
          survaysOpen ? (
            <ExpandLessIcon sx={{ color: "black" }} />
          ) : (
            <FormatListBulletedOutlinedIcon sx={{ color: "black" }} />
          )
        }
      />
      <Collapse in={survaysOpen} unmountOnExit>
        {survayPages(t).map((page, index) => (
          <ListButton
            key={index}
            title={page.title}
            onClick={() => {
              onLinkClick(page.url);
            }}
            icon={page.icon}
            indent={Boolean(page.indent)}
          />
        ))}
      </Collapse>
      {pages(t).map((page, index) => (
        <ListButton
          key={index}
          title={page.title}
          onClick={() => {
            onLinkClick(page.url);
          }}
          icon={page.icon}
          indent={Boolean(page.indent)}
        />
      ))}
      <ListButton
        key={"signout"}
        title={t("navbar.sign_out")}
        onClick={onLogout}
        icon={<ExitToAppOutlinedIcon sx={{ color: "black" }} />}
      />
    </List>
  );
};

export default DrawerContent;
